import * as React from 'react';
import Loader from '../Loader';
import Select from 'antd/lib/select';
import withStyles from 'react-jss';
import { CommonProps } from './common.intefaces';
import { useDebounce } from 'src/hooks/useDebounce';
import { SEARCH_TIMEOUT } from 'src/Library/Constants';
import { isValidArray } from 'src/Library/Helper';
import { commonStyles } from 'src/Library/CommonStyles';
import { StylesProps } from 'src/Library/Types';
import { fetchAddresses, getAddress } from 'src/api/organisationProfiling';
import { SEAddressType, SELocationType } from 'src/components/pages/shipment-execution/SE.interfaces';
import { message } from 'antd';
import _ from 'lodash';


const styles = (theme) => ({
  ...commonStyles(theme),
});
interface IProps extends CommonProps, StylesProps<ReturnType<typeof styles>> {
  addressType: SEAddressType;
  locationType: SELocationType;
  shipperId?: string;
}

const SelectPlant = (props: IProps) => {

  const {
    mode,
    style,
    value,
    classes,
    disabled,
    onChange,
    className,
    placeholder,
    addressType,
    locationType,
    shipperId,
  } = props;

  const [plants, setPlants] = React.useState<any>([]);
  const [searching, setSearching] = React.useState<boolean>(false);
  const [queryString, setQuery] = React.useState<string>('');

  const handlePlantSearch = async () => {
    setSearching(true);
    const response = await fetchAddresses({ addressType, locationType, queryString, shipperId });
    if (response.isSuccess){
      setPlants(prev => {
        const newPlants = response?.data || [];
        const updatedPlants = newPlants.filter(newPlant => 
          !prev.some(existingPlant => existingPlant.id === newPlant.id)
        );
        return [...updatedPlants, ...prev];
      });
    }
    setSearching(false);
  };

  const fetchAddressById = async (id: string) => {
    let stakeholderId: string | undefined;
    const { shipperId } = props;
    if (shipperId) stakeholderId = shipperId;
    const response = await getAddress(id, stakeholderId);
    if (response.isSuccess) {
      setPlants(prev => {
        const exists = prev.some(p => p.id === response.data?.id);
        return exists ? prev : [response.data, ...prev];
      });
    } else {
      message.error(response.errorMessage);
    }
  };

  React.useEffect(() => {    
    if (_.isObject(value) && !Array.isArray(value) && value?.key != null){
      fetchAddressById(value?.key as string);
    }
  }, [value]);
  
  const debounceTime = useDebounce(queryString, SEARCH_TIMEOUT);
  React.useEffect(() => {
    // Only search if there's actually a query string (not on initial mount with empty string)
    if (debounceTime !== undefined && debounceTime !== '') {
      setSearching(true);
      handlePlantSearch();
    }
  }, [debounceTime]);

  React.useEffect(() => {
    if (!value && queryString) {
      setQuery('');
    }
  }, [value]);

  const dropdownRender = (menu) => {
    if (searching) return <div
      style={{ padding: '25px' }}>
      <Loader />
    </div>;
    return menu;
  };

  const renderPortOptions = () => {
    return plants?.map((plant) => <Select.Option
      key={plant.id}
      {...plant}
      data-value={plant.name}
    >
      {plant.name}
    </Select.Option>) || [];
  };

  return <Select
    style={{
      ...(style || {}),
    }}
    allowClear
    showSearch
    labelInValue
    value={value}
    disabled={disabled}
    className={className}
    onChange={onChange}
    optionLabelProp="data-value"
    mode={mode || 'default'}
    dropdownRender={dropdownRender}
    onSearch={query => setQuery(query)}
    onFocus={() => handlePlantSearch()}
    filterOption={(inputValue, option) => true}
    placeholder={placeholder || 'Select Ports(s)'}
    getPopupContainer={(trigger: any) => trigger.parentNode}
  >
    {renderPortOptions()}
  </Select>;
};

export default React.memo(withStyles(styles)(SelectPlant));
